export const GET_PIMADATA = "GET_PIMADATA";
export const GET_PIMADATA_DEC_2021 = "GET_PIMADATA_DEC_2021";
export const GET_PIMADATA_NOV_2021 = "GET_PIMADATA_NOV_2021";
export const GET_PIMADATA_OCT_2021 = "GET_PIMADATA_OCT_2021";
export const GET_PIMADATA_SEP_2021 = "GET_PIMADATA_SEP_2021";
export const GET_PIMADATA_AGO_2021 = "GET_PIMADATA_AGO_2021";
export const GET_PIMADATA_JUL_2021 = "GET_PIMADATA_JUL_2021";
export const GET_PIMADATA_JUN_2021 = "GET_PIMADATA_JUN_2021";
export const GET_PIMADATA_MAY_2021 = "GET_PIMADATA_APR_2021";
export const GET_PIMADATA_APR_2021 = "GET_PIMADATA_MAY_2021";
export const GET_PIMADATA_MAR_2021 = "GET_PIMADATA_MAR_2021";
export const GET_PIMADATA_FEB_2021 = "GET_PIMADATA_FEB_2021";
export const GET_PIMADATA_JAN_2021 = "GET_PIMADATA_JAN_2021";
export const GET_PIMADATA_DEC_2020 = "GET_PIMADATA_DEC_2020";
export const GET_PIMADATA_NOV_2020 = "GET_PIMADATA_NOV_2020";
export const GET_PIMADATA_OCT_2020 = "GET_PIMADATA_OCT_2020";
export const GET_PIMADATA_SEP_2020 = "GET_PIMADATA_SEP_2020";
export const GET_PIMADATA_AGO_2020 = "GET_PIMADATA_AGO_2020";
export const GET_PIMADATA_JUL_2020 = "GET_PIMADATA_JUL_2020";
export const GET_PIMADATA_JUN_2020 = "GET_PIMADATA_JUN_2020";
export const GET_PIMADATA_MAY_2020 = "GET_PIMADATA_MAY_2020";
export const GET_PIMADATA_APR_2020 = "GET_PIMADATA_APR_2020";
export const GET_PIMADATA_MAR_2020 = "GET_PIMADATA_MAR_2020";

export const GET_ARIZONADATA = "GET_ARIZONADATA";
export const GET_ARIZONADATA_DEC_2021 = "GET_ARIZONADATA_DEC_2021";
export const GET_ARIZONADATA_NOV_2021 = "GET_ARIZONADATA_NOV_2021";
export const GET_ARIZONADATA_OCT_2021 = "GET_ARIZONADATA_OCT_2021";
export const GET_ARIZONADATA_SEP_2021 = "GET_ARIZONADATA_SEP_2021";
export const GET_ARIZONADATA_AGO_2021 = "GET_ARIZONADATA_AGO_2021";
export const GET_ARIZONADATA_JUL_2021 = "GET_ARIZONADATA_JUL_2021";
export const GET_ARIZONADATA_JUN_2021 = "GET_ARIZONADATA_JUN_2021";
export const GET_ARIZONADATA_MAY_2021 = "GET_ARIZONADATA_APR_2021";
export const GET_ARIZONADATA_APR_2021 = "GET_ARIZONADATA_MAY_2021";
export const GET_ARIZONADATA_MAR_2021 = "GET_ARIZONADATA_MAR_2021";
export const GET_ARIZONADATA_FEB_2021 = "GET_ARIZONADATA_FEB_2021";
export const GET_ARIZONADATA_JAN_2021 = "GET_ARIZONADATA_JAN_2021";
export const GET_ARIZONADATA_DEC_2020 = "GET_ARIZONADATA_DEC_2020";
export const GET_ARIZONADATA_NOV_2020 = "GET_ARIZONADATA_NOV_2020";
export const GET_ARIZONADATA_OCT_2020 = "GET_ARIZONADATA_OCT_2020";
export const GET_ARIZONADATA_SEP_2020 = "GET_ARIZONADATA_SEP_2020";
export const GET_ARIZONADATA_AGO_2020 = "GET_ARIZONADATA_AGO_2020";
export const GET_ARIZONADATA_JUL_2020 = "GET_ARIZONADATA_JUL_2020";
export const GET_ARIZONADATA_JUN_2020 = "GET_ARIZONADATA_JUN_2020";
export const GET_ARIZONADATA_MAY_2020 = "GET_ARIZONADATA_MAY_2020";
export const GET_ARIZONADATA_APR_2020 = "GET_ARIZONADATA_APR_2020";
export const GET_ARIZONADATA_MAR_2020 = "GET_ARIZONADATA_MAR_2020";

export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
